import { Link } from 'react-router-dom';
import { AiFillDashboard } from 'react-icons/ai';

const Breadcrumb = ({ pageName }) => {
  return (
    <div className="mb-6 flex gap-3 flex-row items-center justify-between">
      <h2 className="font-semibold text-2xl text-[#222]">
        {pageName}
      </h2>

      <nav>
        <ol className="flex items-center gap-2">
          <li className='flex items-center gap-1'>
            <AiFillDashboard />
            <Link className="font-medium text-[#222]" to="/admin/dashboard">
              Dashboard /
            </Link>
          </li>
          <li className="font-medium text-primary">{pageName}</li>
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumb;
